import {createAsyncReducer} from '../../standard-actions/reducers'
import {
  IUpdateServicesWithReferenceInt,
  IUpdateServicesWithReferenceIntSuccessAction,
  IUpdateServicesWithReferenceErrorAction,
} from '../actions/update-services-with-reference-int'
import {IServicePerformanceState} from '../state'
import {initialState} from '../state/initial-state'
import {IServiceInt} from '../state/services-int'

export type UpdateServiceswithReferencetInt =
  | IUpdateServicesWithReferenceInt
  | IUpdateServicesWithReferenceIntSuccessAction
  | IUpdateServicesWithReferenceErrorAction

const init = (state: IServicePerformanceState, action: UpdateServiceswithReferencetInt) => ({
  ...state,
  servicesInt: {
    ...state.servicesInt,
    status: action.status,
  },
})

const success = (state: IServicePerformanceState, action: UpdateServiceswithReferencetInt) => {
  const selectedServiceId = (action as IUpdateServicesWithReferenceIntSuccessAction).data.serviceId
  const reference = (action as IUpdateServicesWithReferenceIntSuccessAction).data.reference

  const updatedServices: IServiceInt[] = state.servicesInt.data.services.map((ele) => {
    if (ele.serviceId === selectedServiceId) {
      ele.userReference = reference
    }
    return ele
  })
  return {
    ...state,
    servicesInt: {
      ...state.servicesInt,
      status: action.status,
      data: {
        services: [...updatedServices],
        originalServices: [...updatedServices],
        originalCompanies: state.servicesInt.data.originalCompanies,
        originalLocations: state.servicesInt.data.originalLocations,
        originalServiceTypes: state.servicesInt.data.originalServiceTypes,
        filterInt: state.servicesInt.data.filterInt,
      },
    },
  }
}

const failure = (state: IServicePerformanceState, action: UpdateServiceswithReferencetInt) => ({
  ...state,
  servicesInt: {
    ...state.servicesInt,
    status: action.status,
    error: (action as IUpdateServicesWithReferenceErrorAction).error,
  },
})

export const updateServicesReferenceReducerInt = createAsyncReducer(
  initialState,
  init,
  success,
  failure,
)
